<template lang="pug">
b-form-select(
  :value="value"
  :size="size"
  @input="handleInput"
)
  //- option(value="") {{ $t("message.select_option") }}
  option(v-for="option in options" :value="option.domain_id") {{ option.domain_name }}
</template>

<script>
import config from "@/config";

export default {
  props: {
    module: {
      type: String,
      default: "MEMBER",
    },
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "sm"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted: function() {
    this.getDomainDefaultAvailableList();
  },
  methods: {
    getDomainDefaultAvailableList: function() {
      let url = config.domainDefaultAvailableList();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        module: this.module
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success

          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
  